import i18n from '@/lang/i18n'

export default [
  {
    path: '/admin/apply/compute_power/settings',
    name: 'ComputePowerSettings',
    component: () => import('@/views/apply/compute_power/settings/index.vue'),
    meta: {
      title: i18n.t('saas_agent.settings_manage'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/compute_power/packages',
    name: 'ComputePowerPackages',
    component: () => import('@/views/apply/compute_power/packages/index.vue'),
    meta: {
      title: i18n.t('compute_power.packages_title'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/compute_power/wallet',
    name: 'ComputePowerWallet',
    component: () => import('@/views/apply/compute_power/wallet/index.vue'),
    meta: {
      title: i18n.t('compute_power.wallet_title'),
      headType: 0,
      auth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/apply/compute_power.js